import React from 'react';
import './Badge.css';

export type BadgeVariant = 'success' | 'danger' | 'warning' | 'info' | 'purple' | 'neutral';

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
  dot?: boolean;
}

export const Badge: React.FC<BadgeProps> = ({ variant, children, dot }) => (
  <span className={`badge-shared badge-${variant}`}>
    {dot && <span className="badge-dot" />}
    {children}
  </span>
);

/** Maps a Quality Health status string to the right semantic Badge variant. */
export const qualityStatusVariant = (status: string): BadgeVariant => {
  switch (status) {
    case 'Healthy': return 'success';
    case 'Attention': return 'warning';
    case 'At Risk': return 'danger';
    case 'Critical': return 'danger';
    default: return 'neutral';
  }
};

export default Badge;
